import {
  IconTicket,
  IconLanguage,
  IconGift,
  IconChartBar,
  IconTags,
  IconToggleLeft,
  IconContract,
  IconStar,
  IconScan,
  IconIdBadge2,
  IconShieldCheck,
  IconMailUp,
  IconUserCircle,
  IconCalendarClock,
} from "@tabler/icons-react";

export const FEATURE_STYLES = {
  registrations: { icon: IconTicket, color: "blue" },
  invite_emails: { icon: IconMailUp, color: "blue" },
  multilingual: { icon: IconLanguage, color: "yellow" },
  giveaways: { icon: IconGift, color: "blue" },
  polls: { icon: IconChartBar, color: "blue" },
  surveys: { icon: IconChartBar, color: "blue" },
  attendee_interests_tags: { icon: IconTags, color: "blue" },
  documents: { icon: IconContract, color: "blue" },
  session_ratings: { icon: IconStar, color: "yellow" },
  check_in: { icon: IconScan, color: "blue" },
  badges: { icon: IconIdBadge2, color: "blue" },
  event_compliance: { icon: IconShieldCheck, color: "yellow" },
  attendeeLimit: { icon: IconUserCircle, color: "yellow" },
  autoCloseDays: { icon: IconCalendarClock, color: "blue" },
};

export const DEFAULT_FEATURE_STYLE = { icon: IconToggleLeft, color: "blue" };

export function getFeatureStyle(featureName) {
  return FEATURE_STYLES[featureName] ?? DEFAULT_FEATURE_STYLE;
}

// Colors taken from the public pricing calculator (pricing.congrs.com), where
// the required foundation package is yellow and every add-on package is blue.
export const PACKAGE_COLORS = {
  yellow: "#ffb71b",
  blue: "#71cae6",
};

export const FEATURE_PACKAGE_COLORS = {
  event_foundation: PACKAGE_COLORS.yellow,
  registration_promotion: PACKAGE_COLORS.blue,
  audience_engagement: PACKAGE_COLORS.blue,
  onsite_operations: PACKAGE_COLORS.blue,
  certificates_recognition: PACKAGE_COLORS.blue,
  extended_app_availability: PACKAGE_COLORS.blue,
};

export function getPackageColor(packageKey) {
  return FEATURE_PACKAGE_COLORS[packageKey] ?? PACKAGE_COLORS.blue;
}
